import { Helmet } from 'react-helmet-async';

import { getLocale } from '@frontend/shared';

type Props = {
  title?: string;
  description?: string;
};

export const Seo = ({ title, description }: Props) => {
  if (!title && !description) {
    return null;
  }

  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {title ? <meta property="og:title" content={title} /> : null}
      {title ? <meta name="twitter:title" content={title} /> : null}

      {description ? <meta name="description" content={description} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}

      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:site" content={window.location.href} />
      <meta property="og:image" content="https://www.allocab.com/images/default-og-image.png" />
      <meta property="og:locale" content={getLocale() === 'fr' ? 'fr_FR' : 'en_GB'} />
      <meta property="og:locale:alternate" content={getLocale() === 'fr' ? 'en_GB' : 'fr_FR'} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content="https://www.allocab.com/images/default-og-image.png" />
    </Helmet>
  );
};
